import { CurrencyPipe, NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy, input, inject, EventEmitter, Output, output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CarouselResponse } from '@welcome/interfaces';


@Component({
  selector: 'app-prime-carousel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CurrencyPipe,
    NgClass
  ],
  templateUrl: './prime-carousel.component.html',
  styleUrl: './prime-carousel.component.scss'
})
export class PrimeCarouselComponent {
  data = input<Required<CarouselResponse['responseObject']['list']>>([]);
  onAddFavorite = output<Required<CarouselResponse['responseObject']['list'][0]>>();

  readonly #router = inject(Router);


  get totalFavorites() {
    return this.data().filter(p => p.favorite).length;
  }


  onLoadComercialName(product: any) {
    const { nombre_comercial, modelo_comercial } = product;

    if (!nombre_comercial || nombre_comercial.length === 0) {
      const nombreComercial = modelo_comercial.length > 20
        ? modelo_comercial.slice(0, 20) + '...'
        : modelo_comercial;

      return nombreComercial;
    }

    const nombreComercial = modelo_comercial.length > 20
      ? modelo_comercial.slice(0, 20) + '...'
      : modelo_comercial;

    return nombreComercial;
  }

  onLoadNoImage(img: HTMLImageElement) {
    img.src = '/assets/images/Imagen-no-disponible.jpg';
  }

  onSubmit(sku: string) {
    localStorage.setItem('sku', sku);

    this.#router.navigate(['/registro']);
  }

  addFavorite(btn: HTMLElement, producto: Required<CarouselResponse['responseObject']['list'][0]>) {
    const getButtonClasses = btn.classList;

    const conditional = getButtonClasses.contains('pi-heart') && getButtonClasses.contains('no-selected');
    if (!conditional) {
      this.onAddFavorite.emit(producto);
    }
  }
}
